const locale = {
  COMMON: {
    TXT_TITLE: 'EnOS 文档',
    TXT_DESCRIPTION: 'EnOS 文档帮助你全面了解 EnOS 的产品与服务。',
    TXT_TUTORIAL_TITLE: 'EnOS 快速入门和教程',
    TXT_TUTORIAL_DESCRIPTION: '浏览核心场景教程，快速上手 EnOS。',
    BTN_LAN_SWITCH: '切换语言',
    TXT_DOCUMENTATION: '文档',
    TXT_VERSION: '版本',
    TXT_LANG: '语言',
    TXT_ENOS_LINK_HINT1: '访问',
    TXT_ENOS_LINK_HINT2: 'EnOS 开发者中心',
    TXT_ENOS_LINK_HINT3: '获取 EnOS 活跃版本的最新文档及其他开发资源。',
    TXT_COPY_RIGHT: '© {0} 远景智能版权所有。',
    HINT_NEED_LOGIN: '你还未登录，请先登录',
    TITLE_WRONG_MESSAGE: '错误信息',
    TXT_VERSION_TITLE: '版本信息',
    TXT_LEARN_MORE: ' 了解更多',
    PAGE_NOT_FOUND: '找不到此页面',
    PAGE_NOT_FOUND_DETAIL: '链接地址已变更或此页面不存在。 ',
    NOT_FOUND_TIP: '秒后自动打开',
    HOME_PAGE: '首页',
    CHINESE: '简体中文',
    ENGLISH: '英文',
    SEARCH_DOCUMENT: '在 EnOS 文档中搜索',
    TXT_ALL_PRODUCTS: '所有产品',
    CONTACT_US: '报告安全问题',
    GLOBAL_SEARCH_PLACEHOLDER: '在全局内搜索'
  },
  GLOBAL_SEARCH: {
    SEARCHING: '正在搜索中...',
    SEARCH_RESULT: '搜索结果',
    SEARCH_NO_RESULT: '无搜索结果',
    SEARCH_RESULT_DATA: '搜索完成，共有 {0} 个页面包含“{1}”。',
    SEARCH_NO_RESULT_DATA: '没有任何文档匹配您的搜索。',
    SEARCH: '搜索',
    FILTER: '筛选器',
    PROJECT_NAME: '产品文档',
    VERSION_NAME: '版本',
    ALL_VERSION: '全部版本',
    GO_BACK: '返回',
    FILTER_PRODUCE: '筛选产品名称'
  }
};

export default locale;
